import { TitleCasePipe } from '@angular/common';

const titleCasePipe = new TitleCasePipe();

export function dbStringToGui(dbString: string) {
  return (dbString === 'ANNAT' || dbString === 'EJ_ANGIVET') ? 'Okänt' : titleCasePipe.transform(dbString);
}
